// extracted by mini-css-extract-plugin
export default {"backBtn":"BackBtn_backBtn__v54jo","backBtn__text":"BackBtn_backBtn__text__S9-Tk"};